import { HttpClient } from '@angular/common/http'
import {
  Component, Inject
} from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { environment } from '../../environments/environment'
import { DelphireUser } from '../interfaces/delphire-user'
import { ConfirmationDialogService } from '../services/confirmation-dialog.service'
import { LocalStorageService } from '../services/local-storage-service.service'
import { VerbalizerEmailService } from '../services/verbalizer/verbalizer-email.service'

@Component({
  selector: 'support-dialog',
  templateUrl: './support-dialog.component.html'
})
export class SupportDialogComponent {
  url: string = 'https://mail.modaldigital.io/api/email/send/'
  styles: any = {
    h2: 'font-size: 18px; font-weight: bold; margin: 0 0 8px 0;',
    h3: 'font-size: 16px; font-weight: bold; margin: 0 0 8px 0;',
    div: 'font-size: 14px; font-weight: normal; margin: 0 0 8px 0; padding: 25px',
    ul: 'margin: 0; padding: 0;',
    li: 'display: block; list-style: none; margin: 10px 0; padding: 10px 0;'
  }
  preferences: FormGroup = new FormGroup({
    description: new FormControl(''),
    preferredNumber: new FormControl(''),
    team: new FormControl()
  })
  user: DelphireUser = { user: {} }
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string
    },
    private emailService: VerbalizerEmailService,
    private mdDialogRef: MatDialogRef<SupportDialogComponent>,
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private dialogService: ConfirmationDialogService

  ) {}

  ngOnInit(): void {
    this.localStorage.getItem('delphireUser').subscribe((user) => {
      if (user) {
        this.user = user;
      }
    })
  }

  public cancel() {
    this.close(false)
  }

  public close(value: any) {
    this.mdDialogRef.close(value)
  }

  sendEmail(response: any): Promise<any> {
    console.log('[ Email ] (_send) response', response)
    return new Promise((resolve, reject) => {
      const data: any = {
        to: 'fieldsupport@syneoshealth.com',
        from: 'support@modaldigital.io',
        replyTo: 'fieldsupport@syneoshealth.com',
        cc: this.user.userInfo?.email,
        bcc: null,
        subject: response.subject,
        message: response.message,
        appName: 'Modal'
      }

      console.log('[ Email ] (_send) Sending email', data)
      this.http.post(this.url, data, {
        headers: {
          Authorization: "Bearer " + environment.emailBearerToken,
          "Content-Type": "application/json",
        }
      }).subscribe((resp) => {
        console.log('Email Response', resp)
        resolve(true)
      })
    })
  }

  public confirm() {
    if (this.preferences.get('description')?.value  && this.preferences.get('team')?.value) {
      const dialogOptions = {
        title: 'Are you sure you want to submit this request?',
        message: 'By clicking YES, a request will be submitted to Syneos Field Support.',
        cancelText: 'CANCEL',
        confirmText: 'YES',
        id: 'support',
        panelClass: 'quizDialog',
      }

      this.dialogService.open(dialogOptions)

      this.dialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.sendEmail({
            subject: 'Modal Support Request',
            message: ` 
            <!DOCTYPE html>
            <body style="background-color: #f8f8fa">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse; padding: 0; margin: 0px; vertical-align: top;text-align: left; border-spacing: 0;">
                <tr valign="top" style="padding: 0;vertical-align: top;text-align: left;"
                  <td align="center" style="font-size: 14px; line-height: 19px; color: #222222; font-family: Helvetica, Arial, sans-serif; font-weight: normal;padding: 0; margin: 0 auto; text-align: left;">
                    <table style="border-spacing: 0; border-collapse: collapse; height: 100%; width: 100%; font-size: 14px;line-height:19px;">
                      <tr style="padding: 0; vertical-align: top; text-align: left;">
                        <td align="center" valign="top" style="text-align: center !important;">
                          <center style="width: 100%; min-width: 580px; display: block;">
                            <table style="border-spacing: 0; border-collapse: collapse; width: 580px; margin: 0 auto; text-align: inherit; background-color: #fff;">
                              <tr>
                                <td align="center" style="text-align: center;">
                                  <center style="width: 100%; min-width: 580px; display: block;">
                                    <table style="width: 580px; margin: 0 auto; text-align: inherit; background-color: #fff; border-spacing: 0; border-collapse: collapse;">
                                      <tr>
                                        <td style="position: relative; padding: 0;">
                                          <table style="border-spacing: 0; border-collapse: collapse; width: 580px; margin: 0 auto; background-color: #fff;">
                                            <!-- LOGOS -->
                                            <tr style="padding: 0; vertical-align: top; text-align: left;">
                                              <td style="padding: 0;">
                                                <ul style="padding: 0; margin: 0; text-align: center; width: 100%; font-size: 1.15em; color: #fa771f;">
                                                  <li style="width: 100%; display: inline-block; list-style: none; border:1px solid #eb3300; background-color: #fff; font-weight: lighter;">
                                                    <img src="https://firebasestorage.googleapis.com/v0/b/delphire-depsol.appspot.com/o/Logos%2Flogo.png?alt=media&token=0483f8dc-0f3a-46f3-b4cb-72a17e9b3060" alt="Syneos Deployment Solutions" 
                                                        style="
                                                            width: 20%;
                                                            height: auto;
                                                            max-width: 100%;
                                                            float: right;
                                                            clear: both;
                                                            display: block;
                                                            outline: none;
                                                            text-decoration: none;
                                                            text-align: right;
                                                            padding: 10px 10px 10px 0px;">
                                                  </li>
                                                </ul>
                                              </td>
                                              <td style="visibility: hidden; width: 0px; padding: 0 !important;"></td>
                                            </tr>
                                          </table>
                                        </td>
                                      </tr>
                                    </table>
                                  </center>
                                </td>
                              </tr>
                            </table>
                            <table style="border-collapse: collapse; padding: 0; vertical-align: top; text-align: left; border-spacing: 0; width: 580px; margin: 0 auto; text-align: inherit; background-color: #fff;">
                              <tr>
                                <td>
                                  <table style="display: block; padding: 0px; position: relative; border-collapse: collapse; padding: 0; vertical-align: top; border-spacing: 0; width: 580px; margin: 0 auto; text-align: inherit; background-color: #fff;">
                                    <tr>
                                      <td style="padding: 0px; position: relative;">
                                        <table style="width: 580px; margin: 0 auto;">
                                          <tr>
                                            <td>
                                              <div>
                                                <h2 style="${this.styles.h2}">A new MODAL support request has been submitted:</h2><br/>
                                                <ul style="${this.styles.ul}">
                                                  <li style="${this.styles.li}"><b>Requester's Email</b>: ${this.user.userInfo?.email}</li>
                                                  <li style="${this.styles.li}"><b>Requester's Name</b>: ${this.user.userInfo?.given_name} ${this.user.userInfo?.family_name}</li>
                                                  <li style="${this.styles.li}"><b>Requester's Team</b>: ${this.preferences.get('team')?.value}</li>
                                                  <li style="${this.styles.li}"><b>Preferred Contact Number</b>: ${this.preferences.get('preferredNumber')?.value}</li>
                                                  <li style="${this.styles.li}"><b>Description of Issue</b>: <br /><p>${this.preferences.get('description')?.value}</p></li>
                                                </ul>
                                              </div>
                                            </td>
                                          </tr>
                                        </table>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <table style="border-collapse: collapse; padding: 0; vertical-align: top; text-align: left; border-spacing: 0; width: 580px; display: block; position: relative; background-color: #fff;">
                              <tr>
                                <td align="center" style="text-align: center; padding: 0px; position: relative;">
                                  <table style="display: block; padding: 0px; width: 450px; border-collapse: collapse; vertical-align: top; border-spacing: 0; margin: 0 auto; background-color: #fff;">
                                    <tr>
                                      <td style="text-align: center;">
                                        <p style="width: 580px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; font-size: 11px; color: #4f4f4f; text-align: center; margin-top: -10px;">©2023 All rights reserved | Confidential | For Syneos Health™ use only</p>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </center>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </body>
            `
          })
          this.close(true)
        }
      })
    }else {
      this.close(true)
    }
  }

}
